export interface ApiInterface {
    login: string;
    localization: string;
    settings: string;
    timeZone: string;
    modularity: string;
    measureUnit: string;
    common: {
        boolean: string;
    };
    catalogues: {
        shiftTml: string;
        plywoodSize: string;
        plywoodGrade: string;
        plywoodThickness: string;
        optimizationType: string;
        planDaySchedule: string;
        settingsEquipment: string;
        equipmentType: string;
        warehousePlywood: string;
        plywoodSpecie: string;
        plywoodSurface: string;
        plywoodWaterResistance: string;
        tenonGroove: string;
        warehouseVeneer: string;
        veneerCategory: string;
        veneerKind: string;
        veneerOuterGrade: string;
        veneerPatchingGrade: string;
        veneerSize: string;
        veneerSpecie: string;
        veneerThickness: string;
        veneerType: string;
        veneerWetness: string;
        orderPriority: string;
        calculationType: string;
        planOrderType: string;
        planPriorityOrderType: string;
        woodSpecie: string;
        veneerMaxUsedShiftCountOfStorage: string;
        veneer: string;
        plywoodSurfaceType: string;
        complectationRule: string;
        daySchedule: string;
        orderCustomProperty: string;
        veneerProcessingEquipmentType: string;
        plywoodProcessingEquipmentType: string;
        veneerProductionEquipmentType: string;
        plywoodProductionEquipmentType: string;
        plywoodProductionSupportEquipmentType: string;
        plywoodGroupBy: string;
        veneerGroupBy: string;
        equipmentSettings: string;
        warehouseVeneerEquipmentTypeLink: string;
        warehousePlywoodEquipmentTypeLink: string;
        plywoodProductionDistribution: string;
        equipmentTab: string;
        veneerEquipmentProcess: string;
        veneerEquipmentProcessLink: string;
        veneerEquipmentGroup: string;
        veneerEquipmentGroupLink: string;
        veneerEquipmentProcessGroupLink: string;
        equipmentPlywoodProcessingProcessLink: string;
        plywoodProcessingProcess: string;
        plywoodProcessingProcessGroup: string;
        equipmentPlywoodProcessingProcessGroupLink: string;
        plywoodProcessingProcessGroupLink: string;
        plywoodProductionSupportEquipment: string;
        plywoodProductionEquipment: string;
        plywoodProductionProcess: string;
        veneerProductionEquipment: string;
        veneerProcessingEquipment: string;
        plywoodProcessingEquipment: string;
        roleEnum: string;
    };
    journals: {
        plan: string;
        solve: string;
        schedule: string;
        planShift: string;
        planEquipment: string;
        planWarehousePlywood: string;
        planWarehouseVeneer: string;
        planWarehouseIncomeVeneer: string;
        planOrder: string;
        planResSummaryOrderBalance: string;
        planResSummaryPlywoodBalance: string;
        planResSummaryWarehouseVeneer: string;
        planResSummaryIndicator: string;
        planResByShiftWarehouseVeneer: string;
        planResByShiftOrderBalance: string;
        planResByShiftPlywoodBalance: string;
        planResByShiftRecommendation: string;
        planResByShiftEquipmentVeneerProcessGroupItemDist: string;
        PlanResByShiftEquipmentVeneerProcessGroupItem: string;
        planResByShiftPlywoodEquipmentGroupPlywood: string;
        planResByShiftPlywoodEquipmentGroupPlywoodCmpl: string;
        planResByShiftPlywoodEquipmentGroupPlywoodCmplTrans: string;
        order: string;
        plywoodPriceList: string;
        scheduleEquipmentActivity: string;
        planres: string;
        warehousePlywoodState: string;
        warehousePlywoodAudit: string;
        warehouseVeneerState: string;
        warehouseVeneerAudit: string;
    };
    administration: {
        user: string;
        role: string;
        userRoleLink: string;
        rolePolicyLink: string;
        company: string;
        adminUser: string;
        logging: string;
    };
}

export const api = {
    login: '/login',
    localization: '/localization',
    settings: '/settings',
    timeZone: '/timezone',
    modularity: '/modularity',
    measureUnit: '/measureUnit',
    common: {
        boolean: '/boolean',
    },
    journals: {
        plan: '/plan',
        solve: '/solve',
        schedule: '/schedule',
        planShift: '/planshift',
        planEquipment: '/planequipment',
        planWarehousePlywood: '/planwarehouseplywood',
        planWarehouseVeneer: '/planwarehouseveneer',
        planWarehouseIncomeVeneer: '/planwarehouseincomeveneer',
        planOrder: '/planorder',
        planResSummaryOrderBalance: '/planressummaryorderbalance',
        planResSummaryPlywoodBalance: '/planressummaryplywoodbalance',
        planResSummaryWarehouseVeneer: '/planressummarywarehouseveneer',
        planResSummaryIndicator: '/planressummaryindicator',
        planResByShiftWarehouseVeneer: '/planresbyshiftwarehouseveneer',
        planResByShiftOrderBalance: '/planresbyshiftorderbalance',
        planResByShiftPlywoodBalance: '/planresbyshiftplywoodbalance',
        planResByShiftRecommendation: '/planresbyshiftrecommendation',
        planResByShiftEquipmentVeneerProcessGroupItemDist: '/planresbyshiftequipmentveneerprocessgroupitemdist',
        planResByShiftEquipmentVeneerProcessGroupItem: '/planresbyshiftequipmentveneerprocessgroupitem',
        planResByShiftPlywoodEquipmentGroupPlywood: '/planresbyshiftplywoodequipmentgroupplywood',
        planResByShiftPlywoodEquipmentGroupPlywoodCmpl: '/planresbyshiftplywoodequipmentgroupplywoodcmpl',
        planResByShiftPlywoodEquipmentGroupPlywoodCmplTrans: '/planresbyshiftplywoodequipmentgroupplywoodcmpltrans',
        order: '/order',
        plywoodPriceList: '/plywoodpricelist',
        scheduleEquipmentActivity: '/scheduleequipmentactivity',
        planres: '/planres',
        warehousePlywoodState: '/warehouseplywoodstate',
        warehousePlywoodAudit: '/warehouseplywoodaudit',
        warehouseVeneerState: '/warehouseveneerstate',
        warehouseVeneerAudit: '/warehouseveneeraudit',
    },
    catalogues: {
        shiftTml: '/shifttml',
        plywoodSize: '/plywoodsize',
        plywoodGrade: '/plywoodgrade',
        plywoodThickness: '/plywoodthickness',
        optimizationType: '/optimizationtype',
        planDaySchedule: '/plandayschedule',
        settingsEquipment: '/settingsequipment',
        equipmentType: '/equipmenttype',
        warehousePlywood: '/warehouseplywood',
        plywoodSurface: '/plywoodsurface',
        plywoodSpecie: '/plywoodspecie',
        plywoodWaterResistance: '/plywoodwaterresistance',
        tenonGroove: '/tenongroove',
        warehouseVeneer: '/warehouseveneer',
        veneerCategory: '/veneercategory',
        veneerKind: '/veneerkind',
        veneerOuterGrade: '/veneeroutergrade',
        veneerPatchingGrade: '/veneerpatchinggrade',
        veneerSize: '/veneersize',
        veneerSpecie: '/veneerspecie',
        veneerThickness: '/veneerthickness',
        veneerType: '/veneertype',
        veneerWetness: '/veneerwetness',
        orderPriority: '/orderpriority',
        calculationType: '/calculationtype',
        planOrderType: '/planordertype',
        planPriorityOrderType: '/planpriorityordertype',
        woodSpecie: '/woodspecie',
        veneerMaxUsedShiftCountOfStorage: '/veneermaxusedshiftcountofstorage',
        veneer: '/veneer',
        plywoodSurfaceType: '/plywoodsurfacetype',
        complectationRule: '/complectationrule',
        daySchedule: '/dayschedule',
        orderCustomProperty: '/ordercustomproperty',
        plywoodProcessingEquipmentType: '/plywoodProcessingEquipmentType',
        veneerProcessingEquipmentType: '/veneerprocessingequipmenttype',
        veneerProductionEquipmentType: '/veneerproductionequipmenttype',
        plywoodProductionEquipmentType: '/plywoodproductionequipmenttype',
        plywoodProductionSupportEquipmentType: '/plywoodproductionsupportequipmenttype',
        plywoodGroupBy: '/plywoodgroupby',
        veneerGroupBy: '/veneergroupby',
        equipmentSettings: '/settingsequipment',
        warehouseVeneerEquipmentTypeLink: '/warehouseveneerequipmenttypelink',
        warehousePlywoodEquipmentTypeLink: '/warehouseplywoodequipmenttypelink',
        plywoodProductionDistribution: '/plywoodproductiondistribution',
        equipmentTab: '/equipmenttab',
        veneerEquipmentProcess: '/veneerprocess',
        veneerEquipmentProcessLink: '/equipmentveneerprocesslink',
        veneerEquipmentGroup: '/veneerprocessgroup',
        veneerEquipmentGroupLink: '/veneerprocessgrouplink',
        veneerEquipmentProcessGroupLink: '/equipmentveneerprocessgrouplink',
        plywoodProcessingProcess: '/plywoodProcessingProcess',
        equipmentPlywoodProcessingProcessLink: '/equipmentplywoodprocessingprocesslink',
        plywoodProcessingProcessGroup: '/plywoodprocessingprocessgroup',
        equipmentPlywoodProcessingProcessGroupLink: '/equipmentplywoodprocessingprocessgrouplink',
        plywoodProcessingProcessGroupLink: '/plywoodprocessingprocessgrouplink',
        plywoodProductionSupportEquipment: '/plywoodproductionsupportequipment',
        plywoodProductionEquipment: '/plywoodproductionequipment',
        plywoodProductionProcess: '/plywoodproductionprocess',
        veneerProductionEquipment: '/veneerproductionequipment',
        veneerProcessingEquipment: '/veneerprocessingequipment',
        plywoodProcessingEquipment: '/plywoodprocessingequipment',
        roleEnum: '/roleenum',
    },
    administration: {
        user: '/user',
        role: '/role',
        userRoleLink: '/userRoleLink',
        rolePolicyLink: '/rolePolicyLink',
        company: '/company',
        adminUser: '/adminUser',
        logging: '/logging',
    },
};

export default api;
